



















































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { ScreenText } from '@/lang/ScreenText';
import APP_UTILITIES from '@/utilities/commonFunctions';
import cartStore from '@/store/modules/checkout/cart/module';
import { CustomFeesTotalLineItem, CustomFeesTotal } from '@/Model/checkout/cart/types';

@Component
export default class SubmitTotals extends Mixins(DeviceWidthCheckerMixin) {
  @Prop({ type: Boolean, default: false }) readonly useSubmitted!: boolean;
  public readonly screenText = new ScreenText();

  get formattedSubtotal(): string {
    const value = this.useSubmitted && cartStore.submittedCart
      ? cartStore.submittedCart.totals.subtotal
      : cartStore.subtotal;
    return APP_UTILITIES.currencyFmt.format(value);
  }

  get formattedPromoCodeTotal(): string {
    const value = this.useSubmitted && cartStore.submittedCart
      ? cartStore.submittedCart.totals.promoCodeDiscount
      : (cartStore.promoCodeTotal || 0);
    return APP_UTILITIES.currencyFmt.format(value);
  }

  get formattedTax(): string {
    const value = this.useSubmitted && cartStore.submittedCart
      ? cartStore.submittedCart.totals.tax
      : (cartStore.tax || 0);
    return APP_UTILITIES.currencyFmt.format(value);
  }

  get formattedTotal(): string {
    const value = this.useSubmitted && cartStore.submittedCart
      ? cartStore.submittedCart.totals.total
      : (cartStore.total || 0);
    return APP_UTILITIES.currencyFmt.format(value);
  }

  get showPromoCodeLine(): boolean {
    const value = this.useSubmitted && cartStore.submittedCart
      ? cartStore.submittedCart.totals.promoCodeDiscount
      : (cartStore.promoCodeTotal || 0);
    return value > 0;
  }

  get customFeesTotalLineItem(): CustomFeesTotalLineItem | null {
    let feesToUse: CustomFeesTotal | null = null;
    let feeTotalLineItem: CustomFeesTotalLineItem | null = null;

    if (this.useSubmitted && !!cartStore.submittedCart && !!cartStore.submittedCart.totals.customFeesTotal) {
      feesToUse = cartStore.submittedCart.totals.customFeesTotal;
    }
    else if (!this.useSubmitted && !!cartStore.customFeesTotal) {
      feesToUse = cartStore.customFeesTotal;
    }

    // As of right now there is only one Fee for a Payment Account.
    // Defaulting to use the 1st one for the name & tooltip description since it's currently the same across all Sessions
    // and unknown how multiple Fees may be handled in the future (i.e. it may not be a line item per Fee in the totals).
    if (feesToUse && feesToUse.customFees[0]) {
      const name = feesToUse.customFees[0].name.trim();
      const description = feesToUse.customFees[0].description && feesToUse.customFees[0].description.trim();
      const formattedCurrencyTotal = APP_UTILITIES.currencyFmt.format(feesToUse.feesTotalExcludingTax);
      feeTotalLineItem = { name, description, formattedCurrencyTotal };
    }

    return feeTotalLineItem;
  }
}
